import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import * as _ from "lodash";
import { LoadingBarService } from "@ngx-loading-bar/core";

import { HeaderService, ReportsService } from "../../../shared";

@Component({
  selector: "app-reports-list",
  templateUrl: "./reports-list.component.html",
  styleUrls: ["./reports-list.component.scss"]
})
export class ReportsListComponent implements OnInit {
  typeComponent = "reports";

  currentUrl = "/panel/reports";

  dataList;

  pag;
  filters;
  cacheObj;

  reportRequest;

  totalReports;

  constructor(
    private headerService: HeaderService,
    private loadingBarService: LoadingBarService,
    private activatedRoute: ActivatedRoute,
    private reportsService: ReportsService
  ) {
    if (this.activatedRoute.snapshot.params.pag) {
      this.pag = this.activatedRoute.snapshot.params.pag;
    } else {
      this.pag = 1;
    }
  }

  ngOnInit() {
    this.headerService.changeTitle("Relatórios");

    this.headerService.changeSubtitle("");

    this.headerService.changeDatePicker(false);

    this.dataList = {};

    this.translateFilter();
  }

  reportList(filters = "") {
    this.loadingBarService.stop();

    this.loadingBarService.start();

    if (this.reportRequest) {
      this.reportRequest.unsubscribe();
    }

    this.reportRequest = this.reportsService
      .listReports(filters)
      .subscribe(response => {
        this.loadingBarService.complete();

        //atualizar mock
        let mockData = {
          tbody: [
            {
              data: [
                "#963842156",
                "Loja 0048 - Corifeu",
                "Prestador de Ar Condicionado",
                "RAIA",
                "Notas parcialmente emitidas",
                "ABERTO",
                {
                  actions: ["view"],
                  endpoints: null,
                  id: 1
                }
              ]
            }
          ],
          thead: [
            "ABERTURA",
            "LOJA",
            "UF",
            "BANDEIRA",
            "PRESTADOR DE SERVIÇO",
            "STATUS",
            "AÇÕES"
          ],
          total: 1
        };

        this.dataList = mockData;

        this.totalReports = mockData.total;
      });
  }

  setPag(setPag) {
    this.pag = setPag;

    this.translateFilter();
  }

  translateFilter(obj?) {
    this.filters = [];

    if (obj) {
      this.cacheObj = obj;
    }

    _.forOwn(this.cacheObj, (value, key) => {
      this.filters.push(`${key}=${value}`);
    });

    this.reportList(`?pageNumber=${this.pag}&` + this.filters.join("&"));
  }
}
